import { Button, CardItem, Tag, Typography } from "@hellocarbo/lasagne";
import { FC, SVGProps } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import useSegmentEvent from "@/hooks/useSegmentEvent";

type CoachingItemProps = {
  title: string;
  description: string;
  Icon: FC<SVGProps<SVGSVGElement>>;
};

function CoachingItem({ title, description, Icon }: CoachingItemProps) {
  const { t } = useTranslation("coaching");
  const { sendSegmentEvent } = useSegmentEvent();

  return (
    <li>
      <CardItem className="gap-x-md flex items-center">
        <Icon role="img" className="size-2xl" />
        <div className="gap-y-2xs flex grow flex-col">
          <Typography as="h2" step="1" weight="bold">
            {title}
          </Typography>
          <Typography weight="semibold" className="text-grayscale">
            {description}
          </Typography>
        </div>
        <div className="gap-x-sm flex">
          <Tag text={t("coaching:price")} />
          <Button
            intent="secondary"
            shape="soft"
            size="small"
            as={Link}
            to="/options/subscription?option=service4"
            onClick={() => sendSegmentEvent("option_subscription")}
          >
            {t("coaching:cta")}
          </Button>
        </div>
      </CardItem>
    </li>
  );
}

export default CoachingItem;
